import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { useEffect, useRef } from 'react';
import i18n from 'i18next';
import { useSelector, useDispatch } from 'react-redux';
import _ from 'lodash';
import { TablePagination } from '@material-ui/core';
import DropDown from '../ui/react-ui/dropdown';
import DataTable from '../ui/table'; // api

import { getLogsGates } from '../../api/statsAPI'; // redux

import { setLogsGates, setLogsGatesSelected, setGatesSort, setLogsGatesRowPerPage, setLogsGatesCurrentPage, setLogsGatesTotal } from '../../redux/stats-dashboard';
var t = i18n.getFixedT(null, 'stats-dashboard');
var StatsDashboardGatesLog = /*#__PURE__*/React.memo(function (props) {
  var _useSelector = useSelector(function (state) {
    return state.toJS();
  }),
      contextRoot = _useSelector.envCfg.contextRoot,
      _useSelector$statsDas = _useSelector.statsDashboard,
      logsGates = _useSelector$statsDas.logsGates,
      logsGatesSelected = _useSelector$statsDas.logsGatesSelected,
      dateTime = _useSelector$statsDas.dateTime,
      gatesSort = _useSelector$statsDas.gatesSort,
      logsGatesCurrentPage = _useSelector$statsDas.logsGatesCurrentPage,
      logsGatesRowsPerPage = _useSelector$statsDas.logsGatesRowsPerPage,
      logsGatesTotal = _useSelector$statsDas.logsGatesTotal,
      zonesList = _useSelector.app.zonesList;

  var dispatch = useDispatch();
  var isMounted = useRef(false);

  var handleChange = function handleChange(zoneId) {
    dispatch(setLogsGatesSelected(zoneId));
  };

  var handleSort = function handleSort(sort) {
    dispatch(setGatesSort(sort));
  };

  var handleChangePage = function handleChangePage(e, newPage) {
    dispatch(setLogsGatesCurrentPage(newPage));
  };

  var handleChangeRowsPerPage = function handleChangeRowsPerPage(e) {
    dispatch(setLogsGatesRowPerPage(parseInt(e.target.value, 10)));
    dispatch(setLogsGatesCurrentPage(0));
  };

  useEffect(function () {
    if (!isMounted.current) return;
    var offset = (Number(logsGatesCurrentPage + 1) - 1) * logsGatesRowsPerPage;
    getLogsGates(contextRoot, false, logsGatesSelected, dateTime, gatesSort, offset, logsGatesRowsPerPage).then(function (result) {
      var newData = _.map(result.content, function (el, index) {
        return _objectSpread(_objectSpread({}, el), {}, {
          sequence: offset + index + 1
        });
      });

      dispatch(setLogsGates(newData));
      if (!_.isEqual(logsGatesTotal, result.totalElements)) dispatch(setLogsGatesTotal(result.totalElements));
    });
  }, [JSON.stringify(gatesSort), logsGatesCurrentPage, logsGatesRowsPerPage, logsGatesSelected]);
  useEffect(function () {
    if (!isMounted.current) isMounted.current = true;
  }, []);
  var fields = {};

  _.set(fields, 'sequence', {
    label: t('lbl-sequence')
  });

  _.set(fields, 'gateName', {
    label: t('lbl-gates-name'),
    sortable: true
  });

  _.set(fields, 'trailerPlateNo', {
    label: t('lbl-trailerPlateNo'),
    sortable: true
  });

  _.set(fields, 'containerNo1', {
    label: t('lbl-terminal-number1'),
    sortable: true
  });

  _.set(fields, 'containerNo2', {
    label: t('lbl-terminal-number2'),
    sortable: true
  }); // _.set(fields, 'transportType', { label: t('lbl-transport-type'), sortable:true })


  _.set(fields, 'direction', {
    label: t('lbl-direction'),
    sortable: true,
    formatter: function formatter(val, row) {
      return val ? t('lbl-' + val.toUpperCase()) : '';
    }
  });

  _.set(fields, 'passTime', {
    label: t('lbl-passing-time'),
    sortable: true
  });

  return /*#__PURE__*/React.createElement("div", {
    className: "statsDashboard-log"
  }, /*#__PURE__*/React.createElement("div", {
    className: "log-head"
  }, /*#__PURE__*/React.createElement("span", {
    className: "log-title"
  }, t('lbl-gates-log')), /*#__PURE__*/React.createElement("label", {
    className: "label"
  }, t('lbl-terminal-center'), ": "), /*#__PURE__*/React.createElement(DropDown, {
    defaultText: t('lbl-all-terminals-center'),
    list: zonesList,
    value: logsGatesSelected,
    onChange: handleChange
  })), /*#__PURE__*/React.createElement("div", {
    className: "c-border c-position-rlt"
  }, /*#__PURE__*/React.createElement(DataTable, {
    fields: fields,
    sort: gatesSort,
    onSort: handleSort,
    data: logsGates
  })), /*#__PURE__*/React.createElement(TablePagination, {
    component: "div",
    labelRowsPerPage: t('lbl-per-page-row-count'),
    count: logsGatesTotal,
    page: logsGatesCurrentPage,
    onChangePage: handleChangePage,
    rowsPerPage: logsGatesRowsPerPage,
    onChangeRowsPerPage: handleChangeRowsPerPage
  }));
});
export default StatsDashboardGatesLog;